/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Label, Input } from "../../revvComponents";

// Components Imports
import QuotationUpload from "../QuotationUpload/QuotationUpload";

// Actions Imports
import { DocumentTemplateActions } from "../../actions";
import {
  saveDocument,
  updateSelectedDocCategory,
} from "../../actions/DocumentActions";

// Destructuring
const { fetchDocumentTemplatesById } = DocumentTemplateActions;

// Declarations
const FORM = "form";

class CreateDocumentPopup extends Component {
  state = {
    selectedCategoryID: null,
    docURI: null,
    docSource: "template",
    selectedTemplate: null,
    loadingTemplates: false,
    sources: [
      {
        type: "upload",
        label: "Upload Document",
      },
      {
        type: "template",
        label: "Choose Template",
      },
    ],
    errMsg: "",
  };

  componentDidMount() {
    const { documentTypes } = this.props;
    const quoteOption = documentTypes.find(
      item => item.name.toLowerCase() === "Quote/Order Form".toLowerCase(),
    );
    if (quoteOption) {
      this._selectCategory(quoteOption.name, quoteOption.id);
      this.props.updateSelectedDocCategory("Quote/Order Form");
    } else {
      this.props.updateSelectedDocCategory("");
    }
  }

  _submitData = () => {
    const { selectedCategoryID, docURI, selectedTemplate } = this.state;
    this.props.saveDocument(selectedCategoryID, docURI, selectedTemplate);
  };

  _selectCategory = (categoryName, categoryID) => {
    this.props.updateSelectedDocCategory(categoryName);
    if (categoryName.toLowerCase() === "quote/order form") {
      this.setState({
        docSource: "template",
        sources: [
          {
            type: "template",
            label: "Choose Template",
          },
          {
            type: "upload",
            label: "Upload Document",
          },
          {
            type: "blank",
            label: "Blank Document",
          },
        ],
      });
    } else {
      this.setState({
        docSource: "template",
        sources: [
          {
            type: "template",
            label: "Choose Template",
          },
          {
            type: "upload",
            label: "Upload Document",
          },
        ],
      });
    }

    this.setState({ loadingTemplates: true });
    this.props
      .fetchDocumentTemplatesById(categoryID)
      .then(() => this.setState({ loadingTemplates: false }));
    this.setState({ selectedCategoryID: categoryID });
  };

  _chooseCategory = () => {
    const { documentTypes } = this.props;
    const { selectedCategoryID } = this.state;
    const category = documentTypes.map(item => {
      let className = "category-box";
      if (selectedCategoryID === item.id) {
        className += " active";
      }
      return (
        <span
          className={className}
          key={item.id}
          id={item.name}
          onClick={() => this._selectCategory(item.name, item.id)}
          onKeyPress={() => this.props._selectCategory(item.name, item.id)}
          role="button"
          tabIndex="0">
          {item.name}
        </span>
      );
    });
    return category;
  };

  _resetFileDetails = () => {
    this.setState({ docURI: null, errMsg: "" });
  };

  _setDoc = docDetails => {
    const { name: opportunityName } = this.props.opportunity;
    const { fileDetails, error } = docDetails;
    if (error) {
      this.setState({ errMsg: error });
    } else {
      saveDocument(fileDetails, opportunityName).then(uri => {
        if (typeof uri === "string") {
          this.setState({ docURI: uri, errMsg: "" });
        } else {
          this.setState({
            docURI: undefined,
            errMsg: "Invalid content in the uploaded docx file",
          });
        }
      });
    }
  };

  _uploadDocument = () => {
    const { selectedCategoryID, docURI } = this.state;
    if (selectedCategoryID !== null) {
      return (
        <QuotationUpload
          uploaded={docURI !== null}
          setDoc={this._setDoc}
          resetFileDetails={this._resetFileDetails}
        />
      );
    }
    return null;
  };

  _selectTemplate = item => {
    this.setState({ selectedTemplate: item });
  };

  _displayTemplates = () => {
    const { documentTemplates } = this.props;
    const { selectedTemplate, loadingTemplates } = this.state;

    // Show loading message
    if (loadingTemplates) {
      return <span className="loader-label"> Loading templates . . . . </span>;
    }

    // If there are no templates for the category selected
    if (Array.isArray(documentTemplates) && documentTemplates.length === 0) {
      return (
        <div className="from-template">
          <div className="no-template-label">
            No templates are available for this category
            <span role="img" aria-label="Sad">
              😕
            </span>
          </div>
        </div>
      );
    }
    const category = null;
    if (Array.isArray(documentTemplates)) {
      documentTemplates.map(item => {
        const isTemplateTypeForm = item.template_type === FORM;
        if (item.Active) {
          return (
            <div
              className={`template-box ${
                selectedTemplate === item.id ? "is-active" : ""
              }`}
              id={item.title}
              onClick={() => this._selectTemplate(item.id)}
              onKeyPress={() => {}}
              role="button"
              tabIndex="-1">
              <i
                className={`template-box-ico ${
                  isTemplateTypeForm ? "is-form" : ""
                }`}>
                <FontAwesomeIcon
                  icon={[
                    "fas",
                    `${isTemplateTypeForm ? "file-invoice" : "file-alt"}`,
                  ]}
                />
              </i>
              <span className="template-doc-name">{item.title}</span>
            </div>
          );
        }
      });
    }

    return category;
  };

  _selectSource = event => {
    if (event.target.value === "blank") {
      this.setState({ docSource: event.target.value, selectedTemplate: null });
    } else {
      this.setState({ docSource: event.target.value });
    }
  };

  _validateNext = () => {
    const { docSource, selectedCategoryID, docURI, selectedTemplate } =
      this.state;
    if (docSource === "blank") {
      return true;
    }
    if (docSource === "template" && selectedTemplate) {
      return true;
    }
    if (selectedCategoryID && docURI) {
      return true;
    }
    return false;
  };

  render() {
    const { docSource, selectedCategoryID, sources } = this.state;

    const { show, closePopup } = this.props;
    const { name: opportunityName, crm_account: { name: accountName } = {} } =
      this.props.opportunity;

    const popupHeaderSpace = (
      <div className="pipeline-doc">
        <div className="account-details-container">
          <span className="account-details-metatitle">
            <i>
              <FontAwesomeIcon icon={["far", "crown"]} />
            </i>
            Opportunity
          </span>
          <span className="pipeline-opportunity">{opportunityName}</span>
        </div>
        <div className="account-details-container">
          <span className="account-details-metatitle">
            <i>
              <FontAwesomeIcon icon={["far", "briefcase"]} />
            </i>
            Account
          </span>
          <span className="pipeline-acc">{accountName}</span>
        </div>
      </div>
    );
    let errSpace = null;
    if (this.state.errMsg) {
      errSpace = (
        <div className="error-message-wrapper">
          <span className="error-message-icon">
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </span>
          {this.state.errMsg}
        </div>
      );
    }

    return (
      <div className="createdocumentpopup">
        <Modal
          open={show}
          onClose={closePopup}
          closeOnOverlayClick={false}
          center>
          <div className="row">
            <div className="col-md-12">
              <div className="createdoc-title">Create New Document</div>
              <div className="popup-form">
                {popupHeaderSpace}
                {errSpace}
                <div className="choose-category-title">Choose a category</div>
                <div className="category-column">{this._chooseCategory()}</div>
                {selectedCategoryID && (
                  <div
                    className="choose-doc-source"
                    onChange={this._selectSource}
                    data-test="createdocumentpopup-select-source">
                    {sources.map(source => (
                      <span key={source.type} className="choose-doc-sourcetype">
                        <Label>
                          <Input
                            type="radio"
                            name="choose_source"
                            value={source.type}
                            checked={docSource === source.type}
                            onChange={this._selectSource}
                            data-test="createdocumentpopup-radio"
                          />
                          {source.label}
                        </Label>
                      </span>
                    ))}
                  </div>
                )}
                {docSource === "upload" && (
                  <div className="upload-document">
                    {this._uploadDocument()}
                  </div>
                )}
                {docSource === "template" && (
                  <div className="select-template">
                    {this._displayTemplates()}
                  </div>
                )}
                <div className="createquotepopup-footer popup-footer clearfix">
                  <div className="footer-actions">
                    <button
                      type="submit"
                      className="btn btn-transparent createquotepopup-footer-cancelbtn"
                      onClick={closePopup}
                      data-test="createdocumentpopup-discard-btn">
                      Discard
                    </button>
                    <button
                      type="submit"
                      onClick={this._submitData}
                      className="btn btn-primary"
                      disabled={!this._validateNext()}
                      data-test="createdocumentpopup-next-btn">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { accounts, opportunitiesByAccount } = state.OpportunitiesStore;
  const { documentTemplates } = state.TemplateStore;
  return { accounts, opportunitiesByAccount, documentTemplates };
};

const mapDispatchToProps = {
  fetchDocumentTemplatesById,
  updateSelectedDocCategory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateDocumentPopup);
